import { getAssistantSideBySideQuery } from '@/components/assistant/assistantLayout';

/**
 * Live answer from `GuideLayoutBridge`, which uses the same hook as the
 * Buddy panel. `null` means the bridge has not reported yet.
 */
let sideBySideOverride: boolean | null = null;

export function setGuideSideBySideAvailable(value: boolean | null): void {
  sideBySideOverride = value;
}

/**
 * Whether a guide may start. Prefers the bridge so the check matches the
 * panel (sidebar width included). Before the bridge paints, fall back to the
 * side-by-side media query with no sidebar — the bridge corrects it on the
 * first render of the shell.
 */
export function canStartGuideOnThisScreen(): boolean {
  if (sideBySideOverride !== null) return sideBySideOverride;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(getAssistantSideBySideQuery(0)).matches;
}
